import { render, staticRenderFns } from "./ReporteGeneralJuridica.vue?vue&type=template&id=1426643f&scoped=true"
import script from "./ReporteGeneralJuridica.vue?vue&type=script&lang=js"
export * from "./ReporteGeneralJuridica.vue?vue&type=script&lang=js"
import style0 from "./ReporteGeneralJuridica.vue?vue&type=style&index=0&id=1426643f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1426643f",
  null
  
)

export default component.exports